import { jsx } from "react/jsx-runtime";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { validateTidalLicense } from "../../base/index.js";
function AccessTime(props) {
  return /* @__PURE__ */ jsx(
    AccessTimeIcon,
    {
      "data-testid": "AccessTime",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AccessTime",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
AccessTime.tidalIconMeta = {
  categories: "map,location,time",
  name: "AccessTime"
};
validateTidalLicense();
export {
  AccessTime
};
//# sourceMappingURL=AccessTime.js.map
